export default function debounce(fn: Function, delay: number): Function {
  let timerId;
  // eslint-disable-next-line func-names
  return function (...args) {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      fn(...args);
      timerId = null;
    }, delay);
  };
}
